import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Homepage from './pages/Homepage';
import BlogPost from './pages/BlogPost';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Flyer from  './pages/Flyer';
import Hallucinations from './pages/Hallucinations';
import HighCortisolSummer from './pages/HighCortisolSummer';
const RoutesConfig = () => {
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/post/:id" element={<BlogPost />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/shows/:id" element={<Flyer/>} />
      <Route path="/hallucinations" element={<Hallucinations />} />
      <Route path="/high-cortisol-summer" element={<HighCortisolSummer />} />
      {/* Add as many routes as you need */}
    </Routes>
  );
}

export default RoutesConfig;
